<template>
  <WsMain>
    <WsStepper
      :stepperSteps="stepperSteps"
      :value="step"
      @input="$_onStep($event)"
    >
      <template #step-content-1>
        <ValidationObserver
          ref="form"
          class="ws-content-section-observer"
        >
          <WsCreate
            :modelName="modelName"
            :label="label"
            :fields="fields"
            :primary="stepSetting.step1.pageSetting.primary"
            :secondary="stepSetting.step1.pageSetting.secondary"
            v-bind="stepSetting.step1"
            @input="$_onInputStep1($event)"
          >
          </WsCreate>
        </ValidationObserver>
      </template>
      <template #step-content-2>
        <WsCRUD
          ref="WsCrud"
          :label="label"
          :value="selected"
          v-bind="stepSetting.step2"
          @input="$_onSelected($event)"
        >
        </WsCRUD>
      </template>
      <template #step-content-3>
        <WsMultiList
          :value="factoriesData"
          v-bind="stepSetting.step3"
          :iconControlKey="stepSetting.step3.iconControlKey"
        ></WsMultiList>
      </template>
    </WsStepper>
    <WsMainBottomNav>
      <template v-if="step===1">
        <WsBtn
          @click="$router.push(`/ll_broadcast/`)"
          color="textSecondary"
          outlined
        >取消</WsBtn>
      </template>
      <template v-else>
        <WsBtn @click="preStep()">上一步</WsBtn>
      </template>
      <template v-if="stepperSteps.length===step">
        <WsBtn
          @click="$_onSubmit()"
          :loading="loading.submit"
        >發布</WsBtn>
      </template>
      <template v-else>
        <WsBtn @click="nextStep()">下一步</WsBtn>
      </template>
    </WsMainBottomNav>
    <WsAlertDialog
      ref="stopStepDialog"
      title="尚未勾選工廠，無法進到下一步"
      description="請先勾選發布快報工廠名單。"
      @submit="stopStepDialogClose()"
    >
      <template #bottom-btn>
        <WsBtn @click="stopStepDialogClose()">了解</WsBtn>
      </template>
    </WsAlertDialog>
  </WsMain>
</template>

<script>
import model from "@/models/broadcast";
import factoryModel from "@/models/factory";
import H_broadcast from "@/helpers/broadcast";

export default {
  data() {
    return {
      loading: {
        submit: false,
      },
      step: 1,
      stepperSteps: [
        {
          title: "填寫內容與設定",
        },
        {
          title: "選擇發布工廠",
        },
        {
          title: "確認發布清單",
        },
      ],
      factoriesData: [],
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      state: {},
      selected: [],
      stepSetting: {
        step1: {
          titleKey: "name",
          customUpdateAction: (modelData) => {
            if (modelData.question_type === 2) {
              modelData.announce_at = this.$moment(new Date().getTime()).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          },
          pageSetting: {
            primary: [
              {
                type: "infoCard",
                floors: [
                  {
                    title: "快報資訊",
                    fields: ["locales", "attaches"],
                  },
                  {
                    title: "發布資訊",
                    fields: ["announce_at"],
                  },
                ],
              },
            ],
            secondary: [
              {
                type: "infoCard",
                floors: [
                  {
                    title: "分類設定",
                    fields: [
                      "areas",
                      "industry_categories",
                      "system_classes",
                      "system_subclasses",
                    ],
                  },
                ],
              },
            ],
          },
        },
        step2: {
          fields: factoryModel.fields,
          modelName: factoryModel.modelName,
          sortBy: "sequence",
          showFields: [
            "name",
            "area_info",
            "industry_categories",
            "system_class",
          ],
          pageMode: true,
          showExpand: false,
          rowClickRead: false,
          isCreatable: false,
          showTitlebar: false,
          rowClickEmit: true,
          liveSearching: true,
          isMultiSelect: true,
          hasMultiDeleteBtn: false,
          inRowBtnRead: false,
          inRowBtnUpdate: false,
          inRowBtnDelete: false,
          filterSelects: [
            {
              type: "belongsTo",
              label: "",
              textKey: "name",
              modelName: "organization",
              placeholder: "篩選集團",
            },
          ],
        },
        step3: {
          textKey: "name",
          icon: "mdi-domain",
          subIcon: "mdi-factory",
          iconControlKey: "child_factories",
          layerFields: [
            {
              modelKey: "child_factories",
              textKey: "name",
              icon: "mdi-domain",
              subIcon: "mdi-factory",
              iconControlKey: "child_factories",
              innerFields: [
                {
                  modelKey: "factories",
                  textKey: "name",
                  icon: "mdi-factory",
                },
              ],
            },
            {
              modelKey: "factories",
              textKey: "name",
              icon: "mdi-factory",
            },
          ],
        },
      },
    };
  },
  methods: {
    async nextStep() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) return;
      if (this.step === 1) {
        this.selected = await this.$_fetchFilterFactoriesData();
      } else if (this.step === 2) {
        if ((!this.selected || !this.selected.length) && this.state) {
          this.stopStepDialogOpen();
          return;
        } else {
          this.$_fetchFactoriesData();
        }
      }
      this.step += 1;
    },
    preStep() {
      this.step -= 1;
    },
    $_onStep($event) {
      if ($event === 3) {
        if (!this.state.factories || !this.state.factories.length) {
          this.step = 1;
          this.stopStepDialogOpen();
        } else {
          this.$_fetchFactoriesData();
        }
        return;
      }
      this.step = $event;
    },
    $_onInputStep1($event) {
      this.state = {
        ...this.state,
        ...$event,
        announce_at: this.$moment($event.announce_at).startOf('hour'),
      };
    },
    $_onSelected($event) {
      this.selected = $event;
    },
    async $_onSubmit() {
      try {
        this.loading.submit = true;
        this.state.factories = this.$_getFactoryAllIds(this.factoriesData);
        this.state.announce_at = H_broadcast.setAnnounceAt(this.state.announce_at);
        await this.$axios.post(`/${this.modelName}`, this.state);
        this.$router.push(`/ll_broadcast`);
      } catch (err) {
        console.log(err);
      } finally {
        this.loading.submit = false;
        this.$router.push(`/ll_broadcast`);
      }
    },
    $_getFactoryAllIds(items) {
      const ids = [];
      items.forEach((item) => {
        const _ids = this.$_getFactoryIds([], item);
        ids.push(..._ids);
      });
      return ids;
    },
    $_getFactoryIds(ids = [], item) {
      let _ids = [...ids];
      _ids.push(item.id);
      if (item.child_factories && item.child_factories.length > 0) {
        item.child_factories.forEach((sub_item) => {
          _ids = this.$_getFactoryIds(_ids, sub_item);
        });
      }
      return _ids;
    },
    stopStepDialogClose() {
      this.$refs.stopStepDialog.close();
    },
    stopStepDialogOpen() {
      this.$refs.stopStepDialog.open();
    },
    async $_fetchFactoriesData() {
      if (!this.selected || !this.selected.length) return;
      try {
        const _params = {
          factories: this.selected.map((item) => item.id).join(","),
        };
        const res = await this.$axios.get(`/factory_check`, {
          params: _params,
        });
        this.factoriesData = res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
    async $_fetchFilterFactoriesData() {
      try {
        const _params = {
          area: this.state.areas ? this.state.areas.join(",") : null,
          area_section: this.state.area_sections
            ? this.state.area_sections.join(",")
            : null,
          system_classes: this.state.system_classes
            ? this.state.system_classes.join(",")
            : null,
          system_subclasses: this.state.system_subclasses
            ? this.state.system_subclasses.join(",")
            : null,
          industry_categories: this.state.industry_categories
            ? this.state.industry_categories.join(",")
            : null,
          get_all: 1,
        };
        const res = await this.$axios.get(`/factory`, {
          params: _params,
        });
        return res.data.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>